import type { AxiosRequestConfig } from 'axios'
import type { INavigationGraph, NavGraphFormValues } from '~/types/navigation-graph'

import config from '~/config'
import { request } from '~/utils/request'

const initialObject: Record<string, string> = {}

export const getNavigationGraphs = (
  params?: AxiosRequestConfig['params']
): Promise<IPaginatedResponse<INavigationGraph>> => {
  return request({
    params,
    url: `${config.DYNAMIC_SCREEN_API}/navigation-graphs`,
  })
}

export const getNavigationGraph = (navGraphId?: string): Promise<INavigationGraph> => {
  return request({
    url: `${config.DYNAMIC_SCREEN_API}/navigation-graphs/${navGraphId}`,
  })
}

export const createNavigationGraph = ({ data }: { data: NavGraphFormValues }): Promise<INavigationGraph> => {
  return request({
    data: {
      app_key: data.appKey,
      device_type: data.deviceType,
      navigation_target_to_page_container_uuid: data.navigationTargetToPageContainer?.reduce(
        (acc, curr) => ((acc[curr.navigation_target_key] = curr.page_container_uuid), acc),
        initialObject
      ),
      placement: data.placement?.value,
      root_page_container_uuid: data.rootPageContainer?.uuid,
      status: data.status,
      tags: data.tags,
      title: data.title,
    },
    method: 'POST',
    url: `${config.DYNAMIC_SCREEN_API}/navigation-graphs`,
  })
}

export const updateNavigationGraph = ({
  data,
  navGraphId,
}: {
  data: NavGraphFormValues
  navGraphId?: string
}): Promise<void> => {
  return request({
    data: {
      app_key: data.appKey,
      device_type: data.deviceType,
      navigation_target_to_page_container_uuid: data.navigationTargetToPageContainer?.reduce(
        (acc, curr) => ((acc[curr.navigation_target_key] = curr.page_container_uuid), acc),
        initialObject
      ),
      placement: data.placement?.value,
      root_page_container_uuid: data.rootPageContainer?.uuid,
      status: data.status,
      tags: data.tags,
      title: data.title,
    },
    method: 'PUT',
    url: `${config.DYNAMIC_SCREEN_API}/navigation-graphs/${navGraphId}`,
  })
}
